export default {
    oneWayGenerate(booking,vehicleTypes){
        var table = "<table class='table'>";
        table += "<tr>";
        table += "<th style='float:left;justify-content: flex-start;'>";
        table += "Name";
        table += "</th>";
        table += "<td>";
        table += booking.name;
        table += "</td>";
        table += "</tr>";
        table += "<tr>";
        table += "<th style='float:left'>";
        table += "Phone Number";
        table += "</th>";
        table += "<td>";
        table += booking.phoneNumber;
        table += "</td>";
        table += "</tr>";

        table += "<tr>";
        table += "<th style='float:left'>";
        table += "Email";
        table += "</th>";
        table += "<td>";
        table += booking.email;
        table += "</td>";
        table += "</tr>";

        table += "<tr>";
        table += "<th style='float:left'>";
        table += "PickUp Location";
        table += "</th>";
        table += "<td>";
        table += booking.pickupAddress;
        table += "</td>";
        table += "</tr>";

        table += "<tr>";
        table += "<th style='float:left'>";
        table += "Drop Off Location";
        table += "</th>";
        table += "<td>";
        table += booking.dropOffAddress;
        table += "</td>";
        table += "</tr>";

        table += "<tr>";
        table += "<th style='float:left'>";
        table += "Car Type";
        table += "</th>";
        table += "<td>";
        table += vehicleTypes.find(m => m.id == booking.vehicleTypeId)
          .title;
        table += "</td>";
        table += "</tr>";

        table += "<tr>";
        table += "<th style='float:left'>";
        table += "Pick Up Date Time";
        table += "</th>";
        table += "<td>";
        table += booking.pickupDate;
        table += "</td>";
        table += "</tr>";
        table += "<table>";
        return table;
    },
    twoWayGenerate(booking,vehicleTypes){
        var table = "<table class='table'>";
        table += "<tr>";
        table += "<th style='float:left;justify-content: flex-start;'>";
        table += "Name";
        table += "</th>";
        table += "<td>";
        table += booking.name;
        table += "</td>";
        table += "</tr>";
        table += "<tr>";
        table += "<th style='float:left'>";
        table += "Phone Number";
        table += "</th>";
        table += "<td>";
        table += booking.phoneNumber;
        table += "</td>";
        table += "</tr>";

        table += "<tr>";
        table += "<th style='float:left'>";
        table += "Email";
        table += "</th>";
        table += "<td>";
        table += booking.email;
        table += "</td>";
        table += "</tr>";

        table += "<tr>";
        table += "<th style='float:left'>";
        table += "PickUp Location";
        table += "</th>";
        table += "<td>";
        table += booking.pickupAddress;
        table += "</td>";
        table += "</tr>";

        table += "<tr>";
        table += "<th style='float:left'>";
        table += "Drop Off Location";
        table += "</th>";
        table += "<td>";
        table += booking.dropOffAddress;
        table += "</td>";
        table += "</tr>";

        table += "<tr>";
        table += "<th style='float:left'>";
        table += "Return Location";
        table += "</th>";
        table += "<td>";
        table += booking.returnAddress;
        table += "</td>";
        table += "</tr>";

        table += "<tr>";
        table += "<th style='float:left'>";
        table += "Car Type";
        table += "</th>";
        table += "<td>";
        table += vehicleTypes.find(m => m.id == booking.vehicleTypeId)
          .title;
        table += "</td>";
        table += "</tr>";

        table += "<tr>";
        table += "<th style='float:left'>";
        table += "Pick Up Date Time";
        table += "</th>";
        table += "<td>";
        table += booking.pickupDate;
        table += "</td>";
        table += "</tr>";

        table += "<tr>";
        table += "<th style='float:left'>";
        table += "Return Date Time";
        table += "</th>";
        table += "<td>";
        table += booking.returnDate;
        table += "</td>";
        table += "</tr>";

        table += "<table>";
        return table;
    }
}